let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

// hetdakraam, late href (SEMrush-opvolging 15-10-2026, research/semrush-opvolging/interne-links.md).
// Een link met data-hdr-href krijgt die URL pas als iemand hem aanraakt: aanwijzen, focus, tik,
// rechtsklik, middelklik of klik. De server-HTML en een crawler zonder aanraking zien alleen de
// basis-URL van het product, een bezoeker landt op de gekozen maat (?variant=). Gedelegeerd op
// document en in de capture-fase, zodat de href al gezet is voordat de browser navigeert, ook voor
// links die later binnenkomen via Section Rendering. Staat hier en niet inline in theme.liquid,
// omdat pubsub.js op elke pagina laadt en inline JS de text-HTML-verhouding drukt.
(function () {
  function zetLateHref(event) {
    var doel = event.target;
    var link = doel && doel.closest ? doel.closest('a[data-hdr-href]') : null;
    if (!link) return;
    var url = link.getAttribute('data-hdr-href');
    if (url && link.getAttribute('href') !== url) link.setAttribute('href', url);
  }
  ['pointerdown', 'mousedown', 'mouseover', 'focusin', 'touchstart', 'contextmenu', 'auxclick', 'click'].forEach(
    function (naam) {
      document.addEventListener(naam, zetLateHref, { capture: true, passive: true });
    }
  );
})();
